import { AOS_WALLET_URL, IOS_WALLET_URL, IS_IOS } from "constants/pathConstant";
import { useNavigatePage } from "hooks/useNavigatePage";
import { useEffect } from "react";

const SketchWallet = () => {
  const nav = useNavigatePage();

  useEffect(() => {
    nav("/");
    if (IS_IOS) window.location.href = IOS_WALLET_URL;
    else window.location.href = AOS_WALLET_URL;
  }, []);
};

export default SketchWallet;
